import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { Link } from 'react-router-dom';

const HomeFAQ = () => {
  const [openItems, setOpenItems] = useState({});

  const toggleItem = (index) => {
    setOpenItems(prev => ({
      ...prev,
      [index]: !prev[index]
    }));
  };

  const faqData = [
    {
      question: "What services does Mova Astro offer?",
      answer: "We offer comprehensive Vedic astrology services including annual Kundali reading, career and finance reading, marriage and relationship reading, gemstone selection reading, and personalized readings."
    },
    {
      question: "How do I book a consultation?",
      answer: "Simply choose your preferred session type, select an available time slot, and complete the booking process. You'll receive confirmation with session details."
    },
    {
      question: "Are consultations available online?",
      answer: "Yes, we provide online consultations so you can connect with our astrologers from anywhere in the world."
    },
    {
      question: "What payment methods do you accept?",
      answer: "We accept payments in INR and also support international payments in select currencies including USD."
    },
    {
      question: "Can I reschedule my session?",
      answer: "Yes, you can reschedule your session one time to any available slot within 7 calendar days of payment, subject to availability."
    }
  ];

  return (
    <section className="py-16 bg-sand">
      <div className="max-w-4xl mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-indigoDeep text-3xl lg:text-4xl font-semibold mb-4" style={{fontFamily: '"Rubik", sans-serif'}}>
            Frequently Asked Questions
          </h2>
          <p className="text-grayWarm text-lg">Find answers to common questions about our services</p>
        </div>

        <div className="space-y-4">
          {faqData.map((item, index) => (
            <div key={index} className="bg-white rounded-lg shadow-md border border-goldSoft/20">
              <button
                onClick={() => toggleItem(index)}
                className="w-full px-6 py-4 text-left flex justify-between items-center hover:bg-goldSoft/10 transition-colors"
              >
                <h3 className="text-lg font-semibold text-indigoDeep pr-4">{item.question}</h3>
                {openItems[index] ? (
                  <ChevronUp className="w-5 h-5 text-goldSoft flex-shrink-0" />
                ) : (
                  <ChevronDown className="w-5 h-5 text-goldSoft flex-shrink-0" />
                )}
              </button>
              
              {openItems[index] && (
                <div className="px-6 pb-4">
                  <p className="text-grayWarm leading-relaxed">{item.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <p className="text-grayWarm mb-4">Have more questions?</p>
          <Link
            to="/faq"
            className="inline-block px-6 py-3 bg-goldSoft text-indigoDeep font-semibold rounded-md hover:bg-goldHover transition-colors"
          >
            View All FAQs
          </Link>
        </div>
      </div>
    </section>
  );
};

export default HomeFAQ;